import { Box, Tag, Text, VStack } from "@chakra-ui/react";
import { memo, useMemo } from "react";

import ReportDataTable from "../../reports/ReportDataTable";
import { formatNumber } from "../../../store/helpers";
import { AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";
import { getAgentTicketsPerServiceRows } from "../../../store/agentTicketsPerServiceExport";

const PercentMeta = ({ value }) => (
  <Text color="gray.500" fontWeight="semibold" fontSize="xs" textTransform="uppercase">
    ({Number(value || 0).toFixed(2)}%)
  </Text>
);

export const renderAgentTicketsPerServiceCell = (agentData, columnId) => {
  if (columnId === "serviceName") return agentData.serviceName;
  if (columnId === "agentName") return agentData.agentName;
  if (columnId === "total") {
    return <Text color="var(--green)">{formatNumber(agentData.total)}</Text>;
  }
  if (columnId === "percentage") return `${Number(agentData.totalPct || 0).toFixed(2)}%`;
  if (columnId === "average") return formatNumber(agentData.average);
  if (columnId === "min") return formatNumber(agentData.min);
  if (columnId === "max") return formatNumber(agentData.max);
  if (columnId === "completed") {
    return (
      <VStack gap="2px" align="start">
        <Text color="var(--green)">{formatNumber(agentData.numCompleted)}</Text>
        <PercentMeta value={agentData.pctCompleted} />
      </VStack>
    );
  }
  if (columnId === "noShow") {
    return (
      <VStack gap="2px" align="start">
        <Text color="var(--red)">{formatNumber(agentData.numNoShow)}</Text>
        <PercentMeta value={agentData.pctNoShow} />
      </VStack>
    );
  }
  if (columnId === "unattended") {
    return (
      <VStack gap="2px" align="start">
        <Text color="var(--red)">{formatNumber(agentData.numUnattended)}</Text>
        <PercentMeta value={agentData.pctUnattended} />
      </VStack>
    );
  }
  return null;
};

const AgentServicesTable = ({
  serviceData,
  branchName,
  branchIndex,
  index,
  renderConfig,
  onRenderConfigChange,
}) => {
  const rows = useMemo(
    () => getAgentTicketsPerServiceRows({ branchName }, serviceData),
    [branchName, serviceData]
  );
  const { serviceName, totalServiceData } = serviceData;
  const title = `${branchIndex + 1}.${index + 1}. ${serviceName}`;

  return (
    <Box className="agentTicketsPerServiceBlock">
      <h3>{title}</h3>
      {!totalServiceData ? <Text fontSize="sm">No data available for this report</Text> : null}
      <Tag.Root>
        <Tag.Label className="branchTag">{branchName} Branch</Tag.Label>
      </Tag.Root>

      {totalServiceData ? (
        <ReportDataTable
          columns={AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
          rows={rows}
          renderConfig={renderConfig}
          renderCell={renderAgentTicketsPerServiceCell}
          onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
        />
      ) : null}
    </Box>
  );
};

export default memo(AgentServicesTable);
